const gridAutoFlow = {
    name: "grid-auto-flow",
    path: "/grid-auto-flow",
    title: "grid-auto-flow",
    description: "Utilities for controlling how elements in a grid are auto-placed.",
    value: {
        "grid-auto-flow": {
          "grid-flow-row": "row",
          "grid-flow-col": "column",
          "grid-flow-dense": "dense",
          "grid-flow-row-dense": "row dense",
          "grid-flow-col-dense": "column dense",
        }
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="grid grid-flow-row-dense grid-columns-3 grid-rows-3 ...">
  <div class="col-span-2">01</div>
  <div class="col-span-2">02</div>
  <div>03</div>
  <div>04</div>
  <div>05</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="grid grid-flow-col md:grid-flow-row ...">
  <!-- ... -->
</div>        `
            },
        }
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">grid-flow-col, grid-flow-row-dense</code>
                   to control how the auto-placement algorithm works for a grid layout:
            </p>
            <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="grid grid-flow-row-dense grid-columns-3 grid-rows-3 gap-4 rounded-lg text-center font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="col-span-2 grid place-content-center rounded-lg bg-color-pink-500 p-4">01</div>
                    <div class="col-span-2 grid place-content-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="grid place-content-center rounded-lg bg-color-pink-500 p-4">03</div>
                    <div class="grid place-content-center rounded-lg bg-color-pink-500 p-4">04</div>
                    <div class="grid place-content-center rounded-lg bg-color-pink-500 p-4">05</div>
                </div>
            </div>

            
            `
        },
        {
            data: `
           <p class="text-color-gray-600 text-sm dark:text-color-gray-300">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">grid-auto-flow</code>
                  utility with a breakpoint variant like md: to only apply the utility at medium screen sizes and above:
            </p>
            `
        },
    ]
};

export default gridAutoFlow;

<div className="sr-only col-span-2 grid-columns-3 col-span-3 col-start-2  bg-color-blue-200">
<div class="grid grid-flow-row-dense grid-columns-3 grid-rows-3 gap-4 rounded-lg text-center font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="col-span-2 grid place-content-center rounded-lg bg-color-pink-500 p-4">01</div>
                    <div class="col-span-2 grid place-content-center rounded-lg bg-color-pink-300 p-4 dark:bg-color-pink-800 dark:text-fuchsia-400">02</div>
                    <div class="grid place-content-center rounded-lg bg-color-pink-500 p-4">03</div>
                    <div class="grid place-content-center rounded-lg bg-color-pink-500 p-4">04</div>
                    <div class="grid place-content-center rounded-lg bg-color-pink-500 p-4">05</div>
                </div>
</div>